/**
 * Lightweight toast notification utility.
 *
 * Usage:
 *   window.baseTheme.toast('Message saved!');
 *   window.baseTheme.toast('Something went wrong', 'error');
 *   window.baseTheme.toast('Form submitted', 'success', 5000);
 *
 * Types: 'info' (default), 'success', 'warning', 'error'
 * Duration: defaults to 4000ms, pass 0 for persistent (requires dismiss)
 */

(function () {
  var container = null;

  function getContainer() {
    if (container) return container;
    container = document.createElement('div');
    container.className = 'toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'true');
    document.body.appendChild(container);
    return container;
  }

  function toast(message, type, duration) {
    type = type || 'info';
    duration = duration === undefined ? 4000 : duration;

    var el = document.createElement('div');
    el.className = 'toast toast--' + type;
    el.textContent = message;

    var dismiss = document.createElement('button');
    dismiss.className = 'toast__dismiss';
    dismiss.setAttribute('aria-label', 'Dismiss');
    dismiss.textContent = '\u00d7';
    dismiss.addEventListener('click', function () {
      remove(el);
    });
    el.appendChild(dismiss);

    getContainer().appendChild(el);

    // Trigger entrance animation on next frame
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    if (duration > 0) {
      setTimeout(function () {
        remove(el);
      }, duration);
    }
  }

  function remove(el) {
    el.classList.remove('is-visible');
    el.addEventListener('transitionend', function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  window.baseTheme = window.baseTheme || {};
  window.baseTheme.toast = toast;
})();
